export const actions = {
  INVITE_MODAL_OPEN: 'INVITE_MODAL_OPEN',
  INVITE_MODAL_CLOSE: 'INVITE_MODAL_CLOSE',
  INVITE_TOGGLE_BULK_INVITE: 'INVITE_TOGGLE_BULK_INVITE',
  INVITE_MEMBERS_SAVE_REQUEST: 'INVITE_MEMBERS_SAVE_REQUEST',
  INVITE_MEMBERS_SAVE_RESPONSE: 'INVITE_MEMBERS_SAVE_RESPONSE'
};

export default actions;
